define(['./_root'], function(root) {

  /** Built-in value references. */
  var Symbol = root.Symbol;

  return Symbol;
});
